export const UnderlinedTag = ({ text, colorClass = "bg-badger-green", enableHover = false, size = "default" }) => {
	// Map color classes to their rgba values for the underline
	const colorMap = {
		'bg-badger-green': 'rgba(98, 168, 124, 0.5)',
		'bg-badger-blue': 'rgba(47, 151, 193, 0.5)',
		'bg-badger-purple': 'rgba(162, 110, 204, 0.5)',
		'bg-badger-red': 'rgba(214, 64, 69, 0.5)',
		'bg-badger-orange': 'rgba(245, 138, 7, 0.5)',
		'bg-badger-yellow': 'rgba(241, 196, 15, 0.5)',
	};
	
	// For project links with hover, use full opacity colors controlled via CSS
	const hoverColorMap = {
		'bg-badger-green': 'rgba(98, 168, 124, 1)',
		'bg-badger-blue': 'rgba(47, 151, 193, 1)',
		'bg-badger-purple': 'rgba(162, 110, 204, 1)',
		'bg-badger-red': 'rgba(214, 64, 69, 1)',
		'bg-badger-orange': 'rgba(245, 138, 7, 1)',
		'bg-badger-yellow': 'rgba(241, 196, 15, 1)',
	};
	
	const underlineColor = enableHover 
		? (hoverColorMap[colorClass] || hoverColorMap['bg-badger-green'])
		: (colorMap[colorClass] || colorMap['bg-badger-green']);
	
	// Split text into words, preserving spaces
	const words = text.split(/(\s+)/);
	
	return (
		<>
			{words.map((word, index) => {
				// Only wrap non-whitespace words with underline
				if (word.trim() === '') {
					return <span key={index}>{word}</span>;
				}
				
				// Size variants:
				// - "default" + enableHover=false: headline (h-2.5, bottom-0.5) - thickest
				// - "default" + enableHover=true: project links (h-1, bottom-[3px], opacity-40/50) - thinnest
				// - "small": page titles (h-1.5, bottom-[2px]) - medium thickness
				let underlineHeight, underlineBottom, opacityClasses;
				
				if (size === "small") {
					// Page titles - medium thickness (thicker than project links, thinner than headline)
					underlineHeight = "h-1.5";
					underlineBottom = "bottom-[2px]";
					opacityClasses = "";
				} else if (enableHover) {
					// Project links - thinner with hover opacity (back to original perfect state)
					underlineHeight = "h-1";
					underlineBottom = "bottom-[3px]";
					opacityClasses = "transition-opacity duration-200 opacity-40 group-hover:opacity-50";
				} else {
					// Headline - thickest
					underlineHeight = "h-2.5";
					underlineBottom = "bottom-0.5";
					opacityClasses = "";
				}
				
				return (
					<span key={index} className="relative inline-block">
						<span className="relative z-10">{word}</span>
					<span 
						className={`absolute ${underlineBottom} left-0 w-full ${underlineHeight} ${opacityClasses}`}
						style={{
							backgroundColor: underlineColor,
							zIndex: -1,
						}}
					></span>
					</span>
				);
			})}
		</>
	);
};
